import { Country } from '@/types'

export const duprCountries: Array<Country> = [
  {
    name: 'United States',
    dialCode: '+1',
    emoji: '🇺🇸',
    isoCode: 'US',
  },
  {
    name: 'Afghanistan',
    dialCode: '+93',
    emoji: '🇦🇫',
    isoCode: 'AF',
  },
  {
    name: 'Aland Islands',
    dialCode: '+358',
    emoji: '🇦🇽',
    isoCode: 'AX',
  },
  {
    name: 'Albania',
    dialCode: '+355',
    emoji: '🇦🇱',
    isoCode: 'AL',
  },
  {
    name: 'Algeria',
    dialCode: '+213',
    emoji: '🇩🇿',
    isoCode: 'DZ',
  },
  {
    name: 'AmericanSamoa',
    dialCode: '+1684',
    emoji: '🇦🇸',
    isoCode: 'AS',
  },
  {
    name: 'Andorra',
    dialCode: '+376',
    emoji: '🇦🇩',
    isoCode: 'AD',
  },
  {
    name: 'Angola',
    dialCode: '+244',
    emoji: '🇦🇴',
    isoCode: 'AO',
  },
  {
    name: 'Anguilla',
    dialCode: '+1264',
    emoji: '🇦🇮',
    isoCode: 'AI',
  },
  {
    name: 'Antarctica',
    dialCode: '+672',
    emoji: '🇦🇶',
    isoCode: 'AQ',
  },
  {
    name: 'Antigua and Barbuda',
    dialCode: '+1268',
    emoji: '🇦🇬',
    isoCode: 'AG',
  },
  {
    name: 'Argentina',
    dialCode: '+54',
    emoji: '🇦🇷',
    isoCode: 'AR',
  },
  {
    name: 'Armenia',
    dialCode: '+374',
    emoji: '🇦🇲',
    isoCode: 'AM',
  },
  {
    name: 'Aruba',
    dialCode: '+297',
    emoji: '🇦🇼',
    isoCode: 'AW',
  },
  {
    name: 'Australia',
    dialCode: '+61',
    emoji: '🇦🇺',
    isoCode: 'AU',
  },
  {
    name: 'Austria',
    dialCode: '+43',
    emoji: '🇦🇹',
    isoCode: 'AT',
  },
  {
    name: 'Azerbaijan',
    dialCode: '+994',
    emoji: '🇦🇿',
    isoCode: 'AZ',
  },
  {
    name: 'Bahamas',
    dialCode: '+1242',
    emoji: '🇧🇸',
    isoCode: 'BS',
  },
  {
    name: 'Bahrain',
    dialCode: '+973',
    emoji: '🇧🇭',
    isoCode: 'BH',
  },
  {
    name: 'Bangladesh',
    dialCode: '+880',
    emoji: '🇧🇩',
    isoCode: 'BD',
  },
  {
    name: 'Barbados',
    dialCode: '+1246',
    emoji: '🇧🇧',
    isoCode: 'BB',
  },
  {
    name: 'Belarus',
    dialCode: '+375',
    emoji: '🇧🇾',
    isoCode: 'BY',
  },
  {
    name: 'Belgium',
    dialCode: '+32',
    emoji: '🇧🇪',
    isoCode: 'BE',
  },
  {
    name: 'Belize',
    dialCode: '+501',
    emoji: '🇧🇿',
    isoCode: 'BZ',
  },
  {
    name: 'Benin',
    dialCode: '+229',
    emoji: '🇧🇯',
    isoCode: 'BJ',
  },
  {
    name: 'Bermuda',
    dialCode: '+1441',
    emoji: '🇧🇲',
    isoCode: 'BM',
  },
  {
    name: 'Bhutan',
    dialCode: '+975',
    emoji: '🇧🇹',
    isoCode: 'BT',
  },
  {
    name: 'Bolivia, Plurinational State of',
    dialCode: '+591',
    emoji: '🇧🇴',
    isoCode: 'BO',
  },
  {
    name: 'Bosnia and Herzegovina',
    dialCode: '+387',
    emoji: '🇧🇦',
    isoCode: 'BA',
  },
  {
    name: 'Botswana',
    dialCode: '+267',
    emoji: '🇧🇼',
    isoCode: 'BW',
  },
  {
    name: 'Brazil',
    dialCode: '+55',
    emoji: '🇧🇷',
    isoCode: 'BR',
  },
  {
    name: 'British Indian Ocean Territory',
    dialCode: '+246',
    emoji: '🇮🇴',
    isoCode: 'IO',
  },
  {
    name: 'Brunei Darussalam',
    dialCode: '+673',
    emoji: '🇧🇳',
    isoCode: 'BN',
  },
  {
    name: 'Bulgaria',
    dialCode: '+359',
    emoji: '🇧🇬',
    isoCode: 'BG',
  },
  {
    name: 'Burkina Faso',
    dialCode: '+226',
    emoji: '🇧🇫',
    isoCode: 'BF',
  },
  {
    name: 'Burundi',
    dialCode: '+257',
    emoji: '🇧🇮',
    isoCode: 'BI',
  },
  {
    name: 'Cambodia',
    dialCode: '+855',
    emoji: '🇰🇭',
    isoCode: 'KH',
  },
  {
    name: 'Cameroon',
    dialCode: '+237',
    emoji: '🇨🇲',
    isoCode: 'CM',
  },
  {
    name: 'Canada',
    dialCode: '+1',
    emoji: '🇨🇦',
    isoCode: 'CA',
  },
  {
    name: 'Cape Verde',
    dialCode: '+238',
    emoji: '🇨🇻',
    isoCode: 'CV',
  },
  {
    name: 'Cayman Islands',
    dialCode: '+345',
    emoji: '🇰🇾',
    isoCode: 'KY',
  },
  {
    name: 'Central African Republic',
    dialCode: '+236',
    emoji: '🇨🇫',
    isoCode: 'CF',
  },
  {
    name: 'Chad',
    dialCode: '+235',
    emoji: '🇹🇩',
    isoCode: 'TD',
  },
  {
    name: 'Chile',
    dialCode: '+56',
    emoji: '🇨🇱',
    isoCode: 'CL',
  },
  {
    name: 'China',
    dialCode: '+86',
    emoji: '🇨🇳',
    isoCode: 'CN',
  },
  {
    name: 'Christmas Island',
    dialCode: '+61',
    emoji: '🇨🇽',
    isoCode: 'CX',
  },
  {
    name: 'Cocos (Keeling) Islands',
    dialCode: '+61',
    emoji: '🇨🇨',
    isoCode: 'CC',
  },
  {
    name: 'Colombia',
    dialCode: '+57',
    emoji: '🇨🇴',
    isoCode: 'CO',
  },
  {
    name: 'Comoros',
    dialCode: '+269',
    emoji: '🇰🇲',
    isoCode: 'KM',
  },
  {
    name: 'Congo',
    dialCode: '+242',
    emoji: '🇨🇬',
    isoCode: 'CG',
  },
  {
    name: 'Congo, The Democratic Republic of the Congo',
    dialCode: '+243',
    emoji: '🇨🇩',
    isoCode: 'CD',
  },
  {
    name: 'Cook Islands',
    dialCode: '+682',
    emoji: '🇨🇰',
    isoCode: 'CK',
  },
  {
    name: 'Costa Rica',
    dialCode: '+506',
    emoji: '🇨🇷',
    isoCode: 'CR',
  },
  {
    name: "Cote d'Ivoire",
    dialCode: '+225',
    emoji: '🇨🇮',
    isoCode: 'CI',
  },
  {
    name: 'Croatia',
    dialCode: '+385',
    emoji: '🇭🇷',
    isoCode: 'HR',
  },
  {
    name: 'Cuba',
    dialCode: '+53',
    emoji: '🇨🇺',
    isoCode: 'CU',
  },
  {
    name: 'Cyprus',
    dialCode: '+357',
    emoji: '🇨🇾',
    isoCode: 'CY',
  },
  {
    name: 'Czech Republic',
    dialCode: '+420',
    emoji: '🇨🇿',
    isoCode: 'CZ',
  },
  {
    name: 'Denmark',
    dialCode: '+45',
    emoji: '🇩🇰',
    isoCode: 'DK',
  },
  {
    name: 'Djibouti',
    dialCode: '+253',
    emoji: '🇩🇯',
    isoCode: 'DJ',
  },
  {
    name: 'Dominica',
    dialCode: '+1767',
    emoji: '🇩🇲',
    isoCode: 'DM',
  },
  {
    name: 'Dominican Republic',
    dialCode: '+1849',
    emoji: '🇩🇴',
    isoCode: 'DO',
  },
  {
    name: 'Ecuador',
    dialCode: '+593',
    emoji: '🇪🇨',
    isoCode: 'EC',
  },
  {
    name: 'Egypt',
    dialCode: '+20',
    emoji: '🇪🇬',
    isoCode: 'EG',
  },
  {
    name: 'El Salvador',
    dialCode: '+503',
    emoji: '🇸🇻',
    isoCode: 'SV',
  },
  {
    name: 'Equatorial Guinea',
    dialCode: '+240',
    emoji: '🇬🇶',
    isoCode: 'GQ',
  },
  {
    name: 'Eritrea',
    dialCode: '+291',
    emoji: '🇪🇷',
    isoCode: 'ER',
  },
  {
    name: 'Estonia',
    dialCode: '+372',
    emoji: '🇪🇪',
    isoCode: 'EE',
  },
  {
    name: 'Ethiopia',
    dialCode: '+251',
    emoji: '🇪🇹',
    isoCode: 'ET',
  },
  {
    name: 'Falkland Islands (Malvinas)',
    dialCode: '+500',
    emoji: '🇫🇰',
    isoCode: 'FK',
  },
  {
    name: 'Faroe Islands',
    dialCode: '+298',
    emoji: '🇫🇴',
    isoCode: 'FO',
  },
  {
    name: 'Fiji',
    dialCode: '+679',
    emoji: '🇫🇯',
    isoCode: 'FJ',
  },
  {
    name: 'Finland',
    dialCode: '+358',
    emoji: '🇫🇮',
    isoCode: 'FI',
  },
  {
    name: 'France',
    dialCode: '+33',
    emoji: '🇫🇷',
    isoCode: 'FR',
  },
  {
    name: 'French Guiana',
    dialCode: '+594',
    emoji: '🇬🇫',
    isoCode: 'GF',
  },
  {
    name: 'French Polynesia',
    dialCode: '+689',
    emoji: '🇵🇫',
    isoCode: 'PF',
  },
  {
    name: 'Gabon',
    dialCode: '+241',
    emoji: '🇬🇦',
    isoCode: 'GA',
  },
  {
    name: 'Gambia',
    dialCode: '+220',
    emoji: '🇬🇲',
    isoCode: 'GM',
  },
  {
    name: 'Georgia',
    dialCode: '+995',
    emoji: '🇬🇪',
    isoCode: 'GE',
  },
  {
    name: 'Germany',
    dialCode: '+49',
    emoji: '🇩🇪',
    isoCode: 'DE',
  },
  {
    name: 'Ghana',
    dialCode: '+233',
    emoji: '🇬🇭',
    isoCode: 'GH',
  },
  {
    name: 'Gibraltar',
    dialCode: '+350',
    emoji: '🇬🇮',
    isoCode: 'GI',
  },
  {
    name: 'Greece',
    dialCode: '+30',
    emoji: '🇬🇷',
    isoCode: 'GR',
  },
  {
    name: 'Greenland',
    dialCode: '+299',
    emoji: '🇬🇱',
    isoCode: 'GL',
  },
  {
    name: 'Grenada',
    dialCode: '+1473',
    emoji: '🇬🇩',
    isoCode: 'GD',
  },
  {
    name: 'Guadeloupe',
    dialCode: '+590',
    emoji: '🇬🇵',
    isoCode: 'GP',
  },
  {
    name: 'Guam',
    dialCode: '+1671',
    emoji: '🇬🇺',
    isoCode: 'GU',
  },
  {
    name: 'Guatemala',
    dialCode: '+502',
    emoji: '🇬🇹',
    isoCode: 'GT',
  },
  {
    name: 'Guernsey',
    dialCode: '+44',
    emoji: '🇬🇬',
    isoCode: 'GG',
  },
  {
    name: 'Guinea',
    dialCode: '+224',
    emoji: '🇬🇳',
    isoCode: 'GN',
  },
  {
    name: 'Guinea-Bissau',
    dialCode: '+245',
    emoji: '🇬🇼',
    isoCode: 'GW',
  },
  {
    name: 'Guyana',
    dialCode: '+595',
    emoji: '🇬🇾',
    isoCode: 'GY',
  },
  {
    name: 'Haiti',
    dialCode: '+509',
    emoji: '🇭🇹',
    isoCode: 'HT',
  },
  {
    name: 'Holy See (Vatican City State)',
    dialCode: '+379',
    emoji: '🇻🇦',
    isoCode: 'VA',
  },
  {
    name: 'Honduras',
    dialCode: '+504',
    emoji: '🇭🇳',
    isoCode: 'HN',
  },
  {
    name: 'Hong Kong',
    dialCode: '+852',
    emoji: '🇭🇰',
    isoCode: 'HK',
  },
  {
    name: 'Hungary',
    dialCode: '+36',
    emoji: '🇭🇺',
    isoCode: 'HU',
  },
  {
    name: 'Iceland',
    dialCode: '+354',
    emoji: '🇮🇸',
    isoCode: 'IS',
  },
  {
    name: 'India',
    dialCode: '+91',
    emoji: '🇮🇳',
    isoCode: 'IN',
  },
  {
    name: 'Indonesia',
    dialCode: '+62',
    emoji: '🇮🇩',
    isoCode: 'ID',
  },
  {
    name: 'Iran, Islamic Republic of Persian Gulf',
    dialCode: '+98',
    emoji: '🇮🇷',
    isoCode: 'IR',
  },
  {
    name: 'Iraq',
    dialCode: '+964',
    emoji: '🇮🇷',
    isoCode: 'IQ',
  },
  {
    name: 'Ireland',
    dialCode: '+353',
    emoji: '🇮🇪',
    isoCode: 'IE',
  },
  {
    name: 'Isle of Man',
    dialCode: '+44',
    emoji: '🇮🇲',
    isoCode: 'IM',
  },
  {
    name: 'Israel',
    dialCode: '+972',
    emoji: '🇮🇱',
    isoCode: 'IL',
  },
  {
    name: 'Italy',
    dialCode: '+39',
    emoji: '🇮🇹',
    isoCode: 'IT',
  },
  {
    name: 'Jamaica',
    dialCode: '+1876',
    emoji: '🇯🇲',
    isoCode: 'JM',
  },
  {
    name: 'Japan',
    dialCode: '+81',
    emoji: '🇯🇵',
    isoCode: 'JP',
  },
  {
    name: 'Jersey',
    dialCode: '+44',
    emoji: '🇯🇪',
    isoCode: 'JE',
  },
  {
    name: 'Jordan',
    dialCode: '+962',
    emoji: '🇯🇴',
    isoCode: 'JO',
  },
  {
    name: 'Kazakhstan',
    dialCode: '+77',
    emoji: '🇰🇿',
    isoCode: 'KZ',
  },
  {
    name: 'Kenya',
    dialCode: '+254',
    emoji: '🇰🇪',
    isoCode: 'KE',
  },
  {
    name: 'Kiribati',
    dialCode: '+686',
    emoji: '🇰🇮',
    isoCode: 'KI',
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    dialCode: '+850',
    emoji: '🇰🇵',
    isoCode: 'KP',
  },
  {
    name: 'Korea, Republic of South Korea',
    dialCode: '+82',
    emoji: '🇰🇷',
    isoCode: 'KR',
  },
  {
    name: 'Kuwait',
    dialCode: '+965',
    emoji: '🇰🇼',
    isoCode: 'KW',
  },
  {
    name: 'Kyrgyzstan',
    dialCode: '+996',
    emoji: '🇰🇬',
    isoCode: 'KG',
  },
  {
    name: 'Laos',
    dialCode: '+856',
    emoji: '🇱🇦',
    isoCode: 'LA',
  },
  {
    name: 'Latvia',
    dialCode: '+371',
    emoji: '🇱🇻',
    isoCode: 'LV',
  },
  {
    name: 'Lebanon',
    dialCode: '+961',
    emoji: '🇱🇧',
    isoCode: 'LB',
  },
  {
    name: 'Lesotho',
    dialCode: '+266',
    emoji: '🇱🇸',
    isoCode: 'LS',
  },
  {
    name: 'Liberia',
    dialCode: '+231',
    emoji: '🇱🇷',
    isoCode: 'LR',
  },
  {
    name: 'Libyan Arab Jamahiriya',
    dialCode: '+218',
    emoji: '🇱🇾',
    isoCode: 'LY',
  },
  {
    name: 'Liechtenstein',
    dialCode: '+423',
    emoji: '🇱🇮',
    isoCode: 'LI',
  },
  {
    name: 'Lithuania',
    dialCode: '+370',
    emoji: '🇱🇹',
    isoCode: 'LT',
  },
  {
    name: 'Luxembourg',
    dialCode: '+352',
    emoji: '🇱🇺',
    isoCode: 'LU',
  },
  {
    name: 'Macao',
    dialCode: '+853',
    emoji: '🇲🇴',
    isoCode: 'MO',
  },
  {
    name: 'Macedonia',
    dialCode: '+389',
    emoji: '🇲🇰',
    isoCode: 'MK',
  },
  {
    name: 'Madagascar',
    dialCode: '+261',
    emoji: '🇲🇬',
    isoCode: 'MG',
  },
  {
    name: 'Malawi',
    dialCode: '+265',
    emoji: '🇲🇼',
    isoCode: 'MW',
  },
  {
    name: 'Malaysia',
    dialCode: '+60',
    emoji: '🇲🇾',
    isoCode: 'MY',
  },
  {
    name: 'Maldives',
    dialCode: '+960',
    emoji: '🇲🇻',
    isoCode: 'MV',
  },
  {
    name: 'Mali',
    dialCode: '+223',
    emoji: '🇲🇱',
    isoCode: 'ML',
  },
  {
    name: 'Malta',
    dialCode: '+356',
    emoji: '🇲🇹',
    isoCode: 'MT',
  },
  {
    name: 'Marshall Islands',
    dialCode: '+692',
    emoji: '🇲🇭',
    isoCode: 'MH',
  },
  {
    name: 'Martinique',
    dialCode: '+596',
    emoji: '🇲🇶',
    isoCode: 'MQ',
  },
  {
    name: 'Mauritania',
    dialCode: '+222',
    emoji: '🇲🇷',
    isoCode: 'MR',
  },
  {
    name: 'Mauritius',
    dialCode: '+230',
    emoji: '🇲🇺',
    isoCode: 'MU',
  },
  {
    name: 'Mayotte',
    dialCode: '+262',
    emoji: '🇾🇹',
    isoCode: 'YT',
  },
  {
    name: 'Mexico',
    dialCode: '+52',
    emoji: '🇲🇽',
    isoCode: 'MX',
  },
  {
    name: 'Micronesia, Federated States of Micronesia',
    dialCode: '+691',
    emoji: '🇫🇲',
    isoCode: 'FM',
  },
  {
    name: 'Moldova',
    dialCode: '+373',
    emoji: '🇲🇩',
    isoCode: 'MD',
  },
  {
    name: 'Monaco',
    dialCode: '+377',
    emoji: '🇲🇨',
    isoCode: 'MC',
  },
  {
    name: 'Mongolia',
    dialCode: '+976',
    emoji: '🇲🇳',
    isoCode: 'MN',
  },
  {
    name: 'Montenegro',
    dialCode: '+382',
    emoji: '🇲🇪',
    isoCode: 'ME',
  },
  {
    name: 'Montserrat',
    dialCode: '+1664',
    emoji: '🇲🇸',
    isoCode: 'MS',
  },
  {
    name: 'Morocco',
    dialCode: '+212',
    emoji: '🇲🇦',
    isoCode: 'MA',
  },
  {
    name: 'Mozambique',
    dialCode: '+258',
    emoji: '🇲🇿',
    isoCode: 'MZ',
  },
  {
    name: 'Myanmar',
    dialCode: '+95',
    emoji: '🇲🇲',
    isoCode: 'MM',
  },
  {
    name: 'Namibia',
    emoji: '🇳🇦',
    dialCode: '+264',
    isoCode: 'NA',
  },
  {
    name: 'Nauru',
    dialCode: '+674',
    emoji: '🇳🇷',
    isoCode: 'NR',
  },
  {
    name: 'Nepal',
    dialCode: '+977',
    emoji: '🇳🇵',
    isoCode: 'NP',
  },
  {
    name: 'Netherlands',
    dialCode: '+31',
    emoji: '🇳🇱',
    isoCode: 'NL',
  },
  {
    name: 'Netherlands Antilles',
    dialCode: '+599',
    emoji: '🇧🇶',
    isoCode: 'AN',
  },
  {
    name: 'New Caledonia',
    dialCode: '+687',
    emoji: '🇳🇨',
    isoCode: 'NC',
  },
  {
    name: 'New Zealand',
    dialCode: '+64',
    emoji: '🇳🇿',
    isoCode: 'NZ',
  },
  {
    name: 'Nicaragua',
    dialCode: '+505',
    emoji: '🇳🇮',
    isoCode: 'NI',
  },
  {
    name: 'Niger',
    dialCode: '+227',
    emoji: '🇳🇪',
    isoCode: 'NE',
  },
  {
    name: 'Nigeria',
    dialCode: '+234',
    emoji: '🇳🇬',
    isoCode: 'NG',
  },
  {
    name: 'Niue',
    dialCode: '+683',
    emoji: '🇳🇺',
    isoCode: 'NU',
  },
  {
    name: 'Norfolk Island',
    dialCode: '+672',
    emoji: '🇳🇫',
    isoCode: 'NF',
  },
  {
    name: 'Northern Mariana Islands',
    dialCode: '+1670',
    emoji: '🇲🇵',
    isoCode: 'MP',
  },
  {
    name: 'Norway',
    dialCode: '+47',
    emoji: '🇳🇴',
    isoCode: 'NO',
  },
  {
    name: 'Oman',
    dialCode: '+968',
    emoji: '🇴🇲',
    isoCode: 'OM',
  },
  {
    name: 'Pakistan',
    dialCode: '+92',
    emoji: '🇵🇰',
    isoCode: 'PK',
  },
  {
    name: 'Palau',
    dialCode: '+680',
    emoji: '🇵🇼',
    isoCode: 'PW',
  },
  {
    name: 'Palestinian Territory, Occupied',
    dialCode: '+970',
    emoji: '🇵🇸',
    isoCode: 'PS',
  },
  {
    name: 'Panama',
    dialCode: '+507',
    emoji: '🇵🇦',
    isoCode: 'PA',
  },
  {
    name: 'Papua New Guinea',
    dialCode: '+675',
    emoji: '🇵🇬',
    isoCode: 'PG',
  },
  {
    name: 'Paraguay',
    dialCode: '+595',
    emoji: '🇵🇾',
    isoCode: 'PY',
  },
  {
    name: 'Peru',
    dialCode: '+51',
    emoji: '🇵🇪',
    isoCode: 'PE',
  },
  {
    name: 'Philippines',
    dialCode: '+63',
    emoji: '🇵🇭',
    isoCode: 'PH',
  },
  {
    name: 'Pitcairn',
    dialCode: '+872',
    emoji: '🇵🇳',
    isoCode: 'PN',
  },
  {
    name: 'Poland',
    dialCode: '+48',
    emoji: '🇵🇱',
    isoCode: 'PL',
  },
  {
    name: 'Portugal',
    dialCode: '+351',
    emoji: '🇵🇹',
    isoCode: 'PT',
  },
  {
    name: 'Puerto Rico',
    dialCode: '+1939',
    emoji: '🇵🇷',
    isoCode: 'PR',
  },
  {
    name: 'Qatar',
    dialCode: '+974',
    emoji: '🇶🇦',
    isoCode: 'QA',
  },
  {
    name: 'Romania',
    dialCode: '+40',
    emoji: '🇷🇴',
    isoCode: 'RO',
  },
  {
    name: 'Russia',
    dialCode: '+7',
    emoji: '🇷🇺',
    isoCode: 'RU',
  },
  {
    name: 'Rwanda',
    dialCode: '+250',
    emoji: '🇷🇼',
    isoCode: 'RW',
  },
  {
    name: 'Reunion',
    dialCode: '+262',
    emoji: '🇷🇪',
    isoCode: 'RE',
  },
  {
    name: 'Saint Barthelemy',
    dialCode: '+590',
    emoji: '🇧🇱',
    isoCode: 'BL',
  },
  {
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    dialCode: '+290',
    emoji: '🇸🇭',
    isoCode: 'SH',
  },
  {
    name: 'Saint Kitts and Nevis',
    dialCode: '+1869',
    emoji: '🇰🇳',
    isoCode: 'KN',
  },
  {
    name: 'Saint Lucia',
    dialCode: '+1758',
    emoji: '🇱🇨',
    isoCode: 'LC',
  },
  {
    name: 'Saint Martin',
    dialCode: '+590',
    emoji: '🇲🇫',
    isoCode: 'MF',
  },
  {
    name: 'Saint Pierre and Miquelon',
    dialCode: '+508',
    emoji: '🇵🇲',
    isoCode: 'PM',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    dialCode: '+1784',
    emoji: '🇻🇨',
    isoCode: 'VC',
  },
  {
    name: 'Samoa',
    dialCode: '+685',
    emoji: '🇼🇸',
    isoCode: 'WS',
  },
  {
    name: 'San Marino',
    dialCode: '+378',
    emoji: '🇸🇲',
    isoCode: 'SM',
  },
  {
    name: 'Sao Tome and Principe',
    dialCode: '+239',
    emoji: '🇸🇹',
    isoCode: 'ST',
  },
  {
    name: 'Saudi Arabia',
    dialCode: '+966',
    emoji: '🇸🇦',
    isoCode: 'SA',
  },
  {
    name: 'Senegal',
    dialCode: '+221',
    emoji: '🇸🇳',
    isoCode: 'SN',
  },
  {
    name: 'Serbia',
    dialCode: '+381',
    emoji: '🇷🇸',
    isoCode: 'RS',
  },
  {
    name: 'Seychelles',
    dialCode: '+248',
    emoji: '🇸🇨',
    isoCode: 'SC',
  },
  {
    name: 'Sierra Leone',
    dialCode: '+232',
    emoji: '🇸🇱',
    isoCode: 'SL',
  },
  {
    name: 'Singapore',
    dialCode: '+65',
    emoji: '🇸🇬',
    isoCode: 'SG',
  },
  {
    name: 'Slovakia',
    dialCode: '+421',
    emoji: '🇸🇰',
    isoCode: 'SK',
  },
  {
    name: 'Slovenia',
    dialCode: '+386',
    emoji: '🇸🇮',
    isoCode: 'SI',
  },
  {
    name: 'Solomon Islands',
    dialCode: '+677',
    emoji: '🇸🇧',
    isoCode: 'SB',
  },
  {
    name: 'Somalia',
    dialCode: '+252',
    emoji: '🇸🇴',
    isoCode: 'SO',
  },
  {
    name: 'South Africa',
    dialCode: '+27',
    emoji: '🇿🇦',
    isoCode: 'ZA',
  },
  {
    name: 'South Sudan',
    dialCode: '+211',
    emoji: '🇸🇸',
    isoCode: 'SS',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    dialCode: '+500',
    emoji: '🇬🇸',
    isoCode: 'GS',
  },
  {
    name: 'Spain',
    dialCode: '+34',
    emoji: '🇪🇸',
    isoCode: 'ES',
  },
  {
    name: 'Sri Lanka',
    dialCode: '+94',
    emoji: '🇱🇰',
    isoCode: 'LK',
  },
  {
    name: 'Sudan',
    dialCode: '+249',
    emoji: '🇸🇩',
    isoCode: 'SD',
  },
  {
    name: 'Suriname',
    dialCode: '+597',
    emoji: '🇸🇷',
    isoCode: 'SR',
  },
  {
    name: 'Svalbard and Jan Mayen',
    dialCode: '+47',
    emoji: '🇸🇯',
    isoCode: 'SJ',
  },
  {
    name: 'Swaziland',
    dialCode: '+268',
    emoji: '🇸🇿',
    isoCode: 'SZ',
  },
  {
    name: 'Sweden',
    dialCode: '+46',
    emoji: '🇸🇪',
    isoCode: 'SE',
  },
  {
    name: 'Switzerland',
    dialCode: '+41',
    emoji: '🇨🇭',
    isoCode: 'CH',
  },
  {
    name: 'Syrian Arab Republic',
    dialCode: '+963',
    emoji: '🇸🇾',
    isoCode: 'SY',
  },
  {
    name: 'Taiwan',
    dialCode: '+886',
    emoji: '🇹🇼',
    isoCode: 'TW',
  },
  {
    name: 'Tajikistan',
    dialCode: '+992',
    emoji: '🇹🇯',
    isoCode: 'TJ',
  },
  {
    name: 'Tanzania, United Republic of Tanzania',
    dialCode: '+255',
    emoji: '🇹🇿',
    isoCode: 'TZ',
  },
  {
    name: 'Thailand',
    dialCode: '+66',
    emoji: '🇹🇭',
    isoCode: 'TH',
  },
  {
    name: 'Timor-Leste',
    dialCode: '+670',
    emoji: '🇹🇱',
    isoCode: 'TL',
  },
  {
    name: 'Togo',
    dialCode: '+228',
    emoji: '🇹🇬',
    isoCode: 'TG',
  },
  {
    name: 'Tokelau',
    dialCode: '+690',
    emoji: '🇹🇰',
    isoCode: 'TK',
  },
  {
    name: 'Tonga',
    dialCode: '+676',
    emoji: '🇹🇴',
    isoCode: 'TO',
  },
  {
    name: 'Trinidad and Tobago',
    dialCode: '+1868',
    emoji: '🇹🇹',
    isoCode: 'TT',
  },
  {
    name: 'Tunisia',
    dialCode: '+216',
    emoji: '🇹🇳',
    isoCode: 'TN',
  },
  {
    name: 'Turkey',
    dialCode: '+90',
    emoji: '🇹🇷',
    isoCode: 'TR',
  },
  {
    name: 'Turkmenistan',
    dialCode: '+993',
    emoji: '🇹🇲',
    isoCode: 'TM',
  },
  {
    name: 'Turks and Caicos Islands',
    dialCode: '+1649',
    emoji: '🇹🇨',
    isoCode: 'TC',
  },
  {
    name: 'Tuvalu',
    dialCode: '+688',
    emoji: '🇹🇻',
    isoCode: 'TV',
  },
  {
    name: 'Uganda',
    dialCode: '+256',
    emoji: '🇺🇬',
    isoCode: 'UG',
  },
  {
    name: 'Ukraine',
    dialCode: '+380',
    emoji: '🇺🇦',
    isoCode: 'UA',
  },
  {
    name: 'United Arab Emirates',
    dialCode: '+971',
    emoji: '🇦🇪',
    isoCode: 'AE',
  },
  {
    name: 'United Kingdom',
    dialCode: '+44',
    emoji: '🇬🇧',
    isoCode: 'GB',
  },
  {
    name: 'Uruguay',
    dialCode: '+598',
    emoji: '🇺🇾',
    isoCode: 'UY',
  },
  {
    name: 'Uzbekistan',
    dialCode: '+998',
    emoji: '🇺🇿',
    isoCode: 'UZ',
  },
  {
    name: 'Vanuatu',
    dialCode: '+678',
    emoji: '🇻🇺',
    isoCode: 'VU',
  },
  {
    name: 'Venezuela, Bolivarian Republic of Venezuela',
    dialCode: '+58',
    emoji: '🇻🇪',
    isoCode: 'VE',
  },
  {
    name: 'Vietnam',
    dialCode: '+84',
    emoji: '🇻🇳',
    isoCode: 'VN',
  },
  {
    name: 'Virgin Islands, British',
    dialCode: '+1284',
    emoji: '🇻🇬',
    isoCode: 'VG',
  },
  {
    name: 'Virgin Islands, U.S.',
    dialCode: '+1340',
    emoji: '🇻🇮',
    isoCode: 'VI',
  },
  {
    name: 'Wallis and Futuna',
    dialCode: '+681',
    emoji: '🇼🇫',
    isoCode: 'WF',
  },
  {
    name: 'Yemen',
    dialCode: '+967',
    emoji: '🇾🇪',
    isoCode: 'YE',
  },
  {
    name: 'Zambia',
    dialCode: '+260',
    emoji: '🇿🇲',
    isoCode: 'ZM',
  },
  {
    name: 'Zimbabwe',
    dialCode: '+263',
    emoji: '🇿🇼',
    isoCode: 'ZW',
  },
]
